<ng-container dynamicGrid
  [data]="data()"
  [columns]="columns()"
  [grid]="grid()"
  [gridConfig]="gridConfig()"
  [columnSettingsKey]="columnSettingsKey()"
  [lockSelectionCheckbox]="lockSelectionCheckbox()">
</ng-container>